import React, { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { askText } from './AppDialogs';

// A small icon button that copies `text` to the clipboard and shows a tick
// for a moment (first used for the Customer portal address on the Logins
// card, issue #254). See ui-architecture.md "Copy button".
const COPIED_MS = 1500;

function CopyButton({ text, title = 'Copy', style }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), COPIED_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      await askText('Copy this:', { title: 'Copy', confirmLabel: 'Done', defaultValue: text });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={copied ? 'Copied' : title}
      aria-label={copied ? 'Copied' : title}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: 4, border: 'none', background: 'none', borderRadius: 4, cursor: 'pointer', color: copied ? '#1b5e20' : '#5a6b85', ...style }}
    >
      {copied ? <Check size={15} /> : <Copy size={15} />}
    </button>
  );
}

export default CopyButton;
